import type { Employee } from 'src/api/EmployeeService';
import { useParams } from 'react-router';
import { useEmployeeEntry } from '@stores/employeeStore';

const useEmployee = (): {
    employee: Employee | undefined;
    departmentId: string | undefined;
    isLoadingEmployee: boolean;
    refetchEmployee: () => void;
} => {
    const { departmentId, employeeId } = useParams<{
        departmentId: string;
        employeeId: string;
    }>();

    const {
        response: employee,
        isLoading: isLoadingEmployee,
        requestApiCall: refetchEmployee,
    } = useEmployeeEntry(departmentId, employeeId);

    return {
        employee,
        departmentId,
        isLoadingEmployee,
        refetchEmployee,
    };
};

export default useEmployee;
